import { ReactNode } from 'react';
import {
    AttributeOption,
    CallSignOption,
    ManageUnitsUnitGroupEnumType,
    UnitStateGroupEnumType,
    PillUnit,
    SubdivisionOption,
} from '@mark43/cad-api';
import { AdditionalInfoType } from '../additional-infos/types';
import { AdditionalInfoNotificationManager } from '../additional-infos/hooks/use-additional-infos/types';
import { ShowErrorAlert } from '../additional-infos/hooks/use-show-error-alert/use-show-error-alert';

export interface TileUnit {
    beat?: AttributeOption;
    callSign: CallSignOption;
    equipment: AttributeOption[];
    id: number;
    isPrimary: boolean;
    location?: string;
    manageUnitGroup?: ManageUnitsUnitGroupEnumType;
    skills: AttributeOption[];
    statusCode: string;
    statusStartedDateUtc: string;
    unitStateId?: number;
    unitStateGroup: UnitStateGroupEnumType;
    unitClass: string;
    unitTypes: AttributeOption[];
    staffCount?: number;
    totalMiles?: number;
    totalTravelTime?: number;
    totalTravelTimeFormatted?: string;
}

export interface TileEvent {
    agencyTypeGlobalAttrId: number;
    assignedUnits: PillUnit[];
    cfsNumber: string;
    cfsText?: string;
    dispatchArea?: string;
    eventLocation?: string;
    eventNumber: string;
    id: number;
    narrative?: string;
    primaryUnitId?: number;
    timeFirstDispatched?: string;
    timeTransmitted: string;
}

export type GenericObject<PropertiesType> = {
    [key: string]: PropertiesType;
};

export enum ClassificationStrategy {
    MULTI_AGENCY = 'MULTI_AGENCY',
    SINGLE_AGENCY = 'SINGLE_AGENCY',
}

export enum AgencyTypeCapitalized {
    POLICE = 'Police',
    FIRE = 'Fire',
    EMS = 'EMS',
}

export type EventClassPrefix = 'police' | 'fire' | 'ems';

export type SubdivisionFieldSuffix =
    | 'Subdivision1'
    | 'Subdivision2'
    | 'Subdivision3'
    | 'Subdivision4'
    | 'Subdivision5';

export type SubdivisionFieldName = `${EventClassPrefix}${SubdivisionFieldSuffix}`;

export type SubdivisionFieldParam = {
    name: SubdivisionFieldName;
    options: SubdivisionOption[];
    label?: string;
};

export type ResponsiveButton = {
    component: ReactNode;
    breakpoint: number;
    menuItemLabel?: string;
    menuItemOnSelect?: () => void;
    menuItemDisabled?: boolean;
};

export type AdditionalInfosProviderUtils = {
    showErrorAlert: ShowErrorAlert;
    userId: number;
    notificationManager: AdditionalInfoNotificationManager;
    initialFilters: AdditionalInfoType[];
};

// CAD_PRO_QA is implied to be EMS
export type ProQaMessageTypeLegacyElectron = 'CAD_PRO_QA_FIRE' | 'CAD_PRO_QA' | 'CAD_PRO_QA_POLICE';

export type FederatedSearchClientType =
    typeof import('federated-search/FederatedSearchClient').FederatedSearchClient;
